export default "__VITE_ASSET__42453a81__"